export default __webpack_public_path__ + "static/media/O-139.264e906b.png";